import {useScrollToTopOnError} from '@sollapay/ui';

import {ErrorAlertMessage} from './ErrorAlertMessage';

import type {FC, FormEventHandler, ReactNode} from 'react';

export interface FormShellProps {
  id: string;
  className?: string;
  errorClassName?: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
  saveError?: unknown;
  children: ReactNode;
}

/**
 * Thin form wrapper that standardises the <form> element and error display.
 * Pair with useFormShell for AI extraction wiring and form-state sync.
 */
export const FormShell: FC<FormShellProps> = ({
  id,
  className,
  errorClassName,
  onSubmit,
  saveError,
  children
}) => {
  useScrollToTopOnError(saveError);

  return (
    <form id={id} className={className} onSubmit={onSubmit} data-slot={id}>
      {saveError != null && <ErrorAlertMessage error={saveError} className={errorClassName} />}
      {children}
    </form>
  );
};
